import request from "@/router/axios";
export const listByType = (tagType) => {
  return request({
    url: `/api/basis/basis-tag/list`,
    method: "post",
    data: {
      orderBy: "id",
      isDesc: false,
      filterParams: [
        {
          name: "tagType",
          value: tagType,
        },
      ],
    },
  });
};
